export default __webpack_public_path__ + "static/media/survey-form-confirm.8be27ef5.png";